<template>
    <div class="patent-ai-summary px-4">
        <AccordionPanel label="Ai Summary" id="family" type="ai-summary">
            <AonSkeleton
                class="w-full d-flex align-items-center mb-1 flex-wrap"
                :loading="loadingPatentDetail"
                :data="0"
                :height="'80px'"
                light
            >
                <div class="holder">
                    <div
                        v-if="!loadingPatentDetail && noSummary"
                        class="no-patents h-full d-flex align-items-center justify-content-center flex-wrap"
                    >
                        <p class="geist-font semi-bold w-full text-center">
                            No Ai Summary identified on all or parts of this patent
                        </p>
                    </div>
                    <AonCoverLoading :loading="loadingPatentDetail" title="Generating Summary" />
                    <div v-if="!noSummary" class="statements mt-4">
                        <div class="problems">
                            <p
                                class="geist-font semi-bold extra-small uppercase tavern-ale-20--text mb-1"
                                style="font-weight: 700"
                            >
                                Problems
                            </p>
                            <ul style="list-style: circle">
                                <li class="ml-5 mt-2" v-for="item in aiSummary?.problems">
                                    <p
                                        class="geist-font small tavern-ale-40--text m-1 d-inline"
                                        style="font-weight: 500"
                                    >
                                        {{ item.description }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div class="solutions">
                            <p
                                class="geist-font semi-bold extra-small uppercase tavern-ale-20--text mb-1 mt-6"
                                style="font-weight: 700"
                            >
                                Potential Solutions
                            </p>
                            <ul style="list-style: circle">
                                <li class="ml-5 mt-2" v-for="item in aiSummary?.solutions">
                                    <p
                                        class="geist-font small tavern-ale-40--text m-1 d-inline"
                                        style="font-weight: 500"
                                    >
                                        {{ item.description }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div class="benefits">
                            <p
                                class="geist-font semi-bold extra-small uppercase tavern-ale-20--text mb-1 mt-6"
                                style="font-weight: 700"
                            >
                                Value
                            </p>
                            <ul style="list-style: circle">
                                <li class="ml-5 mt-2" v-for="item in aiSummary?.benefits">
                                    <p
                                        class="geist-font small tavern-ale-40--text m-1 d-inline"
                                        style="font-weight: 500"
                                    >
                                        {{ item.description }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </AonSkeleton>
        </AccordionPanel>
    </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { usePatentViewerStore } from '@/stores'
import AccordionPanel from '@/components/helpers/AccordionPanel.vue'

const patentViewerStore = usePatentViewerStore()

const props = defineProps({
    patentDetails: {
        type: Object,
        default: () => ({}),
    },
    loadingPatentDetail: {
        type: Boolean,
        default: false,
    },
})

const aiSummary = computed(() => {
    const patentId = props.patentDetails?.publicationPk
    if (!patentId) return null

    // If we have this summary in cache, return it
    if (patentViewerStore.aiSummaryExistsInCache(patentId)) {
        return patentViewerStore.getCachedAISummary(patentId)
    }

    // If not in cache, cache the current patent details
    if (props.patentDetails && !props.loadingPatentDetail) {
        const summary = {
            problems: props.patentDetails.problems || [],
            solutions: props.patentDetails.solutions || [],
            benefits: props.patentDetails.benefits || [],
        }
        patentViewerStore.setCachedAISummary(patentId, summary)
        return summary
    }

    return null
})

const noSummary = computed(() => {
    if (!aiSummary.value) return true
    if (aiSummary.value.problems?.length === 0) {
        return true
    }
    if (aiSummary.value.solutions?.length === 0) {
        return true
    }
    if (aiSummary.value.benefits?.length === 0) {
        return true
    }
    return false
})
</script>

<style lang="scss" scoped>
.patent-ai-summary {
}
</style>
